import React, { useEffect, useState } from "react";
import "../style/Loading.css";

const Loading: React.FC = () => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShow(false), 5000);
    return () => clearTimeout(timer);
  }, []);

  if (!show) return null; 

  return (
    <div className="loading-root" role="status" aria-live="polite">
      <div className="loader-area">
        <div className="package">
          <div className="lid" />
          <div className="body">
            <div className="inner" />
          </div>
        </div>

        <svg
          className="ring-svg"
          width="120"
          height="120"
          viewBox="0 0 100 100"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle className="ring-bg" cx="50" cy="50" r="45" strokeWidth="10" fill="none" />
          <circle
            className="ring-fg"
            cx="50"
            cy="50"
            r="45"
            strokeWidth="10"
            fill="none"
            strokeDasharray="283"
            strokeDashoffset="280"
          />
        </svg>
      </div>

      <div className="loading-text">Opening a Package...</div>
    </div>
  );
};

export default Loading;
